import React, { useState, useEffect, useRef } from 'react';
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css'; 
import 'react-date-range/dist/theme/default.css'; 
import '../css/DateRangePickerInput.css'; 

const DateRangePickerInput = ({ onRangeChange }) => {
  const [range, setRange] = useState([
    {
      startDate: null, 
      endDate: null,
      key: 'selection',
    },
  ]);
  const [isOpen, setIsOpen] = useState(false);
  const calendarRef = useRef(null);

  const toggleCalendar = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleRangeChange = (item) => {
    if (item.selection.startDate && item.selection.endDate) {
      setRange([item.selection]);
      if (onRangeChange) {
        onRangeChange(item.selection);
      }
    }
  };

  const getPlaceholderText = () => {
    if (!range[0].startDate || !range[0].endDate) {
      return 'From - To';
    }
    return `${range[0].startDate.toLocaleDateString()} - ${range[0].endDate.toLocaleDateString()}`;
  };

  return (
    <div className="date-range-picker-container" ref={calendarRef}>
      <div className="input-wrapper" onClick={toggleCalendar}>
        <span className="calendar-icon">📅</span>
        <span className="placeholder-text ">{getPlaceholderText()}</span>
      </div>
      {isOpen && (
        <div className="calendar-dropdown">
          <DateRangePicker
            ranges={range}
            onChange={handleRangeChange}
            moveRangeOnFirstSelection={false}
            rangeColors={['#3d91ff']} // Optional: Set color for selected range (Mina Magdy)
          />
        </div>
      )}
    </div>
  );
};

export default DateRangePickerInput;
